// initial state
import axios from "axios";
import {getField, updateField} from "vuex-map-fields";

let baseURL = 'https://admin.hoptone.com/api/';
const debug = process.env.NODE_ENV !== 'production';

if (debug) {
    baseURL = 'http://hoptone.test/api/'
} else {
    baseURL = 'https://admin.hoptone.com/api/'
}

const getDefaultState = () => {
    return {
        bulletins: [],
        updateRequired: false,
        status: null,
        internal: null,
    };
};
const state = {
    bulletins: [],
    updateRequired: false,
    status: null,
    internal: null,
};

// getters
const getters = {
    needUpdate: (state) => {
        if (state.status === 'LOADING') {
            return false;
        }

        if (state.updateRequired && state.loading !== 'LOADING') {
            return true;
        }

        if (state.status === 'SUCCESS' && state.bulletins.length > 0) {
            return false;
        }

        return true;
    },
    isLoading() {
        return state.status === 'LOADING';
    },
    bulletins() {
        return state.bulletins;
    },
    internal() {
        return state.internal;
    },
    getField,
};

// actions
const actions = {
        resetState({commit}) {
            commit('resetState')
        },
        load: ({commit, dispatch}) => {
            return new Promise((resolve, reject) => {
                commit('SET_LOADING');
                axios({
                    url: baseURL + 'bulletin', method: 'GET', headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Content-Type': 'application/json',
                    },
                })
                    .then(resp => {
                        commit('SET_SUCCESS');
                        commit('SET_UPDATE_NOT_REQUIRED');
                        commit('SET_BULLETINS', resp.data.data);
                        resolve(resp)
                    })
                    .catch(err => {
                        commit('SET_ERROR');
                        reject(err)
                    })
            })
        },
        save: ({commit, dispatch}, {bulletin, name}) => {
            commit('SET_LOADING');
            return axios({
                url: baseURL + 'bulletin/' + bulletin, method: 'PUT', headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                }, data: {
                    name,
                }
            })
                .then(resp => {
                    let newBulletin = resp.data.data;
                    commit('SET_SUCCESS');
                    commit('SET_BULLETIN_NEW', {bulletin, newBulletin});
                    return Promise.resolve(newBulletin);
                })
                .catch(err => {
                    commit('SET_ERROR');
                    return Promise.reject(err)
                })
        },
        remove: ({commit, dispatch}, {bulletin}) => {
            commit('SET_LOADING');
            return axios({
                url: baseURL + 'bulletin/' + bulletin, method: 'DELETE', headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                }
            }).then(resp => {
                commit('SET_SUCCESS');
                commit('REMOVE_BULLETIN', bulletin);
                commit('SET_UPDATE_REQUIRED');
                return Promise.resolve();
            })
                .catch(err => {
                    commit('SET_ERROR');
                    return Promise.reject(err)
                })
        },
        create: ({commit, dispatch}, {name}) => {
            commit('SET_LOADING');
            return axios({
                url: baseURL + 'bulletin', method: 'POST', headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                }, data: {
                    name: name
                }
            })
                .then(resp => {
                    commit('SET_SUCCESS');
                    commit('SET_UPDATE_REQUIRED');
                    console.log('test1');
                    return Promise.resolve();
                })
                .catch(err => {
                    commit('SET_ERROR');
                    return Promise.reject(err)
                });
        },
        updateField,
    }
;

// mutations
const mutations = {
    resetState(state) {
        Object.assign(state, getDefaultState())
    },
    SET_BULLETINS: (state, bulletins) => state.bulletins = bulletins,
    SET_BULLETIN_NEW: (state, {bulletin, newBulletin}) => {
        state.bulletins.splice(state.bulletins.findIndex(x => x.id === bulletin), 1, newBulletin);
    },
    REMOVE_BULLETIN: (state, bulletin) => {
        state.bulletins.splice(state.bulletins.findIndex(x => x.id === bulletin), 1);
    },
    SET_LOADING: (state) => state.status = 'LOADING',
    SET_SUCCESS: (state) => state.status = 'SUCCESS',
    SET_ERROR: (state) => state.status = 'ERROR',
    SET_UPDATE_REQUIRED: (state) => state.updateRequired = true,
    SET_UPDATE_NOT_REQUIRED: (state) => state.updateRequired = false,

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
